import RestClient from './RestClient';
import { TktInstance, TktUser } from '../../models';

class TktInstances extends RestClient {
    constructor() {
        super({
            "model": TktInstance,
            "entryPoint": "tkt_instance",
            "resource": "tkt_instance",
            "resources": "tkt_instances",
            "sortBy": "name"
        });
    }

    infos(slug) {
        return this.GET(`/tkt_instance/infos/slug/${slug}`)
            .then(response => response.json())
            .then(json => {
                if (json.infos)
                    return json;
                throw new Error(json.flash.error);
            });
    }

    qrImages(params) {
        return this.GET('/tkt_instance/qr_images', params)
            .then(response => response.json())
            .then(json => {
                if (json.qrs)
                    return json;
                throw new Error(json.flash.error);
            });
    }

    pihyveUsers(id) {
        return this.GET(`/tkt_instance/pihyve_users/${id}`)
            .then(response => response.json())
            .then(json => {
                if (json.users)
                    return {
                        ...json,
                        users: json.users.map(u => new TktUser(u))
                    };
                throw new Error(json.flash.error);
            });
    }
}

const TktInstancesApi = new TktInstances();

export default TktInstancesApi;
